import { render, staticRenderFns } from "./totalLibrosXPeriodo.vue?vue&type=template&id=6caff0d4"
import script from "./totalLibrosXPeriodo.vue?vue&type=script&lang=js"
export * from "./totalLibrosXPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports